import { render } from "./form-part-a-overview.html?vue&type=template&id=5edd477e&scoped=true&ts=true&external"
import script from "./form-part-a-overview.ts?vue&type=script&lang=ts&external"
export * from "./form-part-a-overview.ts?vue&type=script&lang=ts&external"

import "./form-part-a-overview.scss?vue&type=style&index=0&id=5edd477e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edd477e"]])

export default __exports__